import { Card } from "antd";
import React from "react";
import Text from "../Text/Text";

interface Props {
  title: string;
  icon: string | React.ReactNode;
  children?: React.ReactNode;
  height?: number;
}

function CardConditionQuota({ title, icon, children, height = 230 }: Props) {
  return (
    <div>
      <Card
        style={{ height: height }}
        title={
          <div style={{ display: "flex", alignItems: "center" }}>
            {typeof icon === "string" ? (
              <img src={icon} alt='icon' style={{ width: 22, marginRight: 8 }} />
            ) : (
              <span style={{ fontSize: 22, marginRight: 8 }}>{icon}</span>
            )}
            <Text fontSize={14} fontWeight={700}>
              {title}
            </Text>
          </div>
        }
      >
        {children}
      </Card>
    </div>
  );
}

export default CardConditionQuota;
